import axios from 'axios';
import marked from 'marked' 

// let flowUrl  = '/njapi/smartprogram/robot_new.php?stream=1'
let flowUrl  = '/szapi/smartprogram/robot_new.php?stream=1'
async function flowRequest(data, anserItem, answerDom) {   

    let userid = localStorage.getItem("userid");
    let member_userid = localStorage.getItem("member_userid");
    let platform = localStorage.getItem("platform");
    let isTest = localStorage.getItem("isTest");
    let appid = localStorage.getItem("appid");

    if (isTest) data.is_test = isTest;
    data.userid = userid ? userid : "";//携带userid传递给后端
    data.member_userid = member_userid ? member_userid : "";//携带member_userid传递给后端
    if (platform) data.platform = platform;
    if (appid) data.appid = appid;

    if (data.action == "reply") {
        let prams = new URLSearchParams(window.location.search)
        if (prams.get("v") != null) {
            data.v = prams.get("v");
        }
        if (prams.get("source") != null) {
            console.log("source参数", prams.get("source"))
            data.source = prams.get("source");
        }
    }



    let char_index = 0
    let text = ""; 

    return new Promise((resolve,reject)=>{
        let over = false
        function type( ) {
            let enableCursor = true;  // 启用光标效果 
            if (char_index < text.length) {
                let txt = answerDom.innerHTML;
                let cursor = enableCursor ? "|" : "";
                if (enableCursor && txt.endsWith("|")) {
                    txt = txt.slice(0, -1);
                    cursor = "";
                }
                answerDom.innerHTML = (txt + text.charAt(char_index) + cursor).replace(/\n/g, "<br>"); 
                char_index++;
                if(over==true&&char_index >= text.length){
                    // console.log("打印完了！！！！！！！！！！！！",text)    
                    let result = marked(text);
                    // console.log(result); 
                    answerDom.innerHTML = result;  
                    anserItem.pro_info.answer = result 

                    resolve({over:true,anserItem:anserItem})
                }
                setTimeout(type, 1000 / 5);  // 打字机速度控制, 每秒5个字  
            }
            

        }


        // 调用服务端的流式接口, 修改为自己的服务器地址和端口号
        fetch(flowUrl, {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify( data 	), 
            responseType: 'stream',
        }).then(response => {  
            answerDom.innerHtml = ""
            answerDom.innerText = ""
            return response.body; 
        }).then(body => {
            // console.log("获得的body",body)
            const reader = body.getReader();
            const decoder = new TextDecoder();
            function read() {
                return reader.read().then(({ done, value }) => { 
                    if (done) { // 读取完成 
                        // anserItem.pro_info.answer = marked(text)
                        over = true; 
                        return false;
                    }  
                    data = decoder.decode(value, { stream: true }); 
                    // console.log("decoder.decode****",data); 
                    if(data.indexOf("}}}{")!=-1){ //有时候会一次返回了多条，如果不拆开处理，JSON.parse的时候会报错
                        let arr = data.split("}}}{");
                        for(let i=0; i<arr.length; i++){ 
                            if(i==0){
                                arr[i] += `}}}`
                            }
                            else if(i==arr.length-1){
                                arr[i] = `{`+arr[i]
                            }
                            else{
                                arr[i] = `{`+arr[i] + `}}}`
                            }
                            let answer_data = JSON.parse(arr[i]);
                            // console.log("answer_data数据对象",answer_data); 
                            text += answer_data.data.pro_info.answer;
                           
                        }   
                    }else{
                        let answer_data = JSON.parse(data);
                        // console.log("answer_data数据对象",answer_data); 
                        text += answer_data.data.pro_info.answer; 
                    }
                     // console.log("text信息：",text)  
                    type( );  // 打字机效果输出 
                    return read();


                    
                });
            }
            return read();
        })
        .catch(error => {
            console.error('发生错误:', error);
            anserItem.pro_info.answer = "请求出错了，请重试";
            resolve({over:false,anserItem:anserItem})
            // reject(error)
        });
    })

}




 



function request(data, methods = "get", file = "robot_new.php") {
    let userid = localStorage.getItem("userid");
    let member_userid = localStorage.getItem("member_userid");
    let platform = localStorage.getItem("platform");
    let isTest = localStorage.getItem("isTest");
    let appid = localStorage.getItem("appid");

    if (isTest) data.is_test = isTest;
    data.userid = userid ? userid : "";//携带userid传递给后端
    data.member_userid = member_userid ? member_userid : "";//携带member_userid传递给后端
    if (platform) data.platform = platform;
    if (appid) data.appid = appid;

    if (data.action == "reply") { 
        let prams = new URLSearchParams(window.location.search)
        if (prams.get("v") != null) {
            data.v = prams.get("v");
        }
        if (prams.get("source") != null) {
            console.log("source参数", prams.get("source"))
            data.source = prams.get("source");
        }
    }


    // let url = `njapi/smartprogram/${file}`;    //测试
    let url = `szapi/smartprogram/${file}`;    //正式
    return new Promise((resolve, reject) => {
        if (methods === "get") {
            // get 请求
            axios({
                methods: methods,		//请求方式，默认为‘get’ ，可省略
                url: url,		//请求的接口网址
                params: data,
                timeout: 60000
            }).then(res => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            })
        } else {
            // post 请求
            axios({
                headers: { "Content-Type": "multipart/form-data" },
                method: 'post',
                url: url,
                data: data,
                timeout: 60000
            }).then(res => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            })
        }
    })
}


export function requestQyWeixin(config) {
    // const baseURL = 'https://hkgw.bendibao.com/weixin_work_api/qywechat/api/v1/' //测试服
    const baseURL = 'https://dgapi.bendibao.com/weixin_work/qywechat/api/v1/'//正式服

    const instance = axios.create({
        baseURL: baseURL,
        timeout: 100000,
        headers: {
            // RequestHeader: "Bearer " + localStorage.authorization,
            // RequestUser: localStorage.userid_h5,
            // RequestQy: localStorage.qy_id_h5,
            'X-Requested-With': 'XMLHttpRequest',
            'Cache-Control': 'no-cache'
        },
    })

    return instance(config);
}



const service = {
    get(url, params) {
        const config = {
            method: "get",
            url: url,
            params: Date.parse(new Date()),
        };
        if (params) config.params = params;
        return request(config);
    },
    post(url, params) {
        const config = {
            method: "post",
            url: url,
        };
        if (params) config.data = params;
        return request(config);
    },
    put(url, params) {
        const config = {
            method: "put",
            url: url,
        };
        if (params) config.params = params;
        return request(config);
    },
};


function getNowDateTime() {
    let dateTime = new Date();
    let Y = dateTime.getFullYear();
    let M = (dateTime.getMonth() + 1).toString().padStart(2, "0");
    let D = dateTime.getDate().toString().padStart(2, "0");
    let h = dateTime.getHours().toString().padStart(2, "0");
    let m = dateTime.getMinutes().toString().padStart(2, "0");

    return `${Y}-${M}-${D} ${h}:${m}`

}



export default {
    request,
    getNowDateTime, 
    flowRequest
} 